import ParsedHtmlContent from "@/components/etc/renderContent";
import { AnalysisListTypes, BoardViewTypes } from "@/type/list";
import default_image from "@/public/icon/default_user.svg"

import mark from "@/public/icon/mark.svg"
import BoardDetailV2 from "@/components/board/detail_v2" ;
import LocaleFormat from "@/components/etc/localeFormat";

export default function AnalysisView({
    selectContent,
    setSelectContent,
    fetchData,
    isFirstRender,
    setIsFirstRender
}: {
    selectContent: BoardViewTypes | undefined;
    setSelectContent: (item: BoardViewTypes | undefined) => void;
    fetchData:()=>void,
    isFirstRender:boolean,
    setIsFirstRender:Function
}) {



  if (!selectContent) return null;


    return (
        <>
        <BoardDetailV2 selectContent={selectContent} 
                    setSelectContent={setSelectContent} 
                    fetchData={fetchData} 
                    post="/api/event/board/" 
                    writeAuth={false}
                    editAuth={false}
                    isComment={false}
                    isrecommend={false}
                    isFirstRender={isFirstRender}
                    setIsFirstRender={setIsFirstRender}
                    
                    renderBody={(c) => (
                        <>
                        <div className="view-title">
                            <header>
                                <div className="title">
                                    {selectContent?.pinned_order !== null && (
                                        <img src="/icon/pinned_icon.png"
                                            style={{ verticalAlign: "middle", marginRight: "4px" }}
                                            alt="pinned" />
                                    )}
                                    {selectContent?.title}
                                    {/* <div dangerouslySetInnerHTML={{ __html: selectContent?.title ?? "" }} ></div> */}
                                </div>
                                <div className="author">
                                    <div className="profile-image">
                                        <img src={default_image.src} alt="" />
                                    </div>
                                    <div className="info">
                                        <div className="nickname">
                                            {selectContent.author_name}
                                        </div>
                                        <span>
                                            <LocaleFormat date={selectContent.create_dt} format="MM-DD HH:mm" />
                                        </span>
                                    </div>
                                </div>
                            </header>
                        </div>
                        <main style={{ overflowWrap: "break-word" }}>
                            <ParsedHtmlContent html={selectContent.content} />
                            {/* <div dangerouslySetInnerHTML={{ __html: selectContent?.content ?? "", }} /> */}
                        </main>
                        </>
                    )} /> 
                    </>
    )
}